import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  DatesFields,
} from '@payler/ui-components';
import { useFormContext } from 'react-hook-form';
import { Box, HStack, Icon, Text } from '@chakra-ui/react';
import { TextStyles } from '@payler/ui-theme';
import { getRangeKey } from '../../helpers/ranges';
import dayjs from 'dayjs';
import { TFieldsKeys } from '../../i18n/namespaces/fields';
import { CloseCircle14Icon } from '@payler/ui-icons';
import { useMerchantCabinetConfig } from '../../config/ConfigProvider';

type Props = {
    /** название поля с датой начала */
    formFieldFrom: string;
  /** название поля с датой окончания */
  formFieldTo: string;
    /** ключ локализации заголовка начальной даты */

  fromKey: string;
    /** ключ локализации заголовка */

  titleKey: string;
  /** ключ локализации заголовка даты окончания */
  toKey: string;
    /** Формат даты */

  dateFormat: string;
};

/**
 * Аккордеон со списком опций для отображения в фильтрах
 */
export const FiltersDateRangeAccordion = (props: Props) => {
  const { environment } = useMerchantCabinetConfig();
  const isProd = environment === 'prod';
  
  return (
    <Box position="relative" zIndex={1}>
      <Accordion alignSelf="stretch">
        <Header {...props} isProd={isProd} />
        <AccordionBody p={2}>
          <DatesFields
            fieldNames={[props.formFieldFrom, props.formFieldTo]}
            stackProps={{ direction: 'column' }}
            labelsKeys={[props.fromKey, props.toKey]}
            dateFormat={props.dateFormat}
            maxDate={dayjs()}
            floating
            showClearButton={!isProd}
          />
        </AccordionBody>
      </Accordion>
    </Box>
  );
};

type HeaderProps = Pick<
  Props,
  'formFieldFrom' | 'formFieldTo' | 'titleKey'
> & {
  isProd: boolean;
};
const Header = ({
  formFieldFrom,
  formFieldTo,
  titleKey,
  isProd,
}: HeaderProps) => {
  const { t } = useTranslation(['fields', 'common']);
  const { watch, setValue } = useFormContext();
  const from = watch(formFieldFrom) as string | null;
  const to = watch(formFieldTo) as string | null;
  const tKey = getRangeKey(from, to);
  const text = t(tKey, { start: from, end: to });
  const showClearButton = !isProd && (from || to);

  return (
    <AccordionHeader>
      <HStack alignItems="center" spacing={2}>
        <Box flex={1}>
          <Text textStyle={TextStyles.tables} color="primary.500">
            {t(titleKey as TFieldsKeys, { ns: 'fields' })}
          </Text>
          <Text textStyle={TextStyles.Caption12Regular} color="primary.300">
            {text}
          </Text>
          <Text textStyle={TextStyles.Caption12Regular} color="primary.300">
            {t('common:datePicker.rangeError', 'Период не может превышать 1 месяц')}
          </Text>
        </Box>
        {showClearButton && (
          <Icon
            as={CloseCircle14Icon}
            onClick={(e) => {
              e.stopPropagation();
              setValue(formFieldFrom, '');
              setValue(formFieldTo, '');
            }}
          />
        )}
      </HStack>
    </AccordionHeader>
  );
};
